import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	autocompleteBoxContent: {
		width: 342,
	},
	autocompleteBox: {
		background: '#C75DA6',
	},
	book: {
		transform: 'translate3d(-20px, -25px, 0)',
	},
	bookOfBidniz: {
		color: '#FFF',
		flexGrow: 1,
		fontSize: 30,
		fontWeight: 800,
		letterSpacing: 3,
		padding: '40px 20px',
		textAlign: 'center',
		textTransform: 'uppercase',
		width: 140,
	},
	checkYoself: {
		cursor: 'pointer',
		fontSize: 20,
		fontWeight: 800,
		letterSpacing: 1.2,
		marginTop: 30,
		textAlign: 'center',
		textDecoration: 'underline',
		textTransform: 'uppercase',
	},
	container: {
		background: '#C75DA6',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		color: '#FFF',
		height: 450,
		marginBottom: 30,
	},
	iconSpan: {
		marginRight: 8,
		marginTop: 4,
	},
	inputContainer: {
		display: 'flex',
		justifyContent: 'center',
		margin: '20px 0',
	},
	or: {
		color: '#FFF',
		fontSize: 14,
		fontWeight: 800,
		letterSpacing: 1.2,
		marginTop: 30,
		textAlign: 'center',
	},
	searchBox: {
		backgroundColor: '#AB3B88',
		border: '1px solid #FFFFFF',
		borderRadius: 3,
		display: 'inline-block',
		fontSize: 14,
		outline: 'none',
		padding: 12,
		verticalAlign: 'middle',
		width: 340,
		...CssSelectors.allChildren(
			{
				'::placeholder': {
					color: 'white',
				},
				color: '#FFF',
			},
			'input'
		),
	},
	topContainer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
});
